var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-content"},[_c('h1',[_vm._v("Alert Content")]),_c('p',[_vm._v("body")]),_c('button',{on:{"click":function($event){return _vm.$emit('resolve')}}},[_vm._v("Close")])])}
var staticRenderFns = []

export { render, staticRenderFns }